import { FormUnit, type GetFormInput } from "@suse-o11y/signal/form";
import { z } from "zod";

import { isStringDirty } from "~/tools/is-string-dirty";

import { MAX, MIN } from "./settings";

const schema = z
	.string()
	.trim()
	.pipe(
		z.union([
			z.literal("").transform(() => undefined),
			z.coerce.number().min(MIN, "Must be a non-negative number").max(MAX, `Must not exceed ${MAX}`),
		]),
	);

type FormState = FormUnit<string, ReadonlyArray<string>, undefined | number>;

type Input = GetFormInput<FormState>;

const INITIAL = "" satisfies Input;

function init(initial?: Input): FormState {
	return FormUnit(initial ?? INITIAL, {
		isInputDirty: isStringDirty,
		schema,
	});
}

const FormState = {
	initial: INITIAL,
	init,
} as const;

export { FormState };
